import {
  ERROR_LOG_MAX_SCREENSHOT_CHARS,
  ERROR_LOG_SCREENSHOT_MAX_WIDTH,
  ERROR_LOG_SCREENSHOT_QUALITIES,
  ERROR_LOG_SCREENSHOT_TIMEOUT_MS
} from 'data/error-log-constants';
import html2canvas from 'html2canvas';
import { getScreenshotScale } from 'utils/error-log/get-screenshot-scale';
import { shouldIgnoreScreenshotElement } from 'utils/error-log/should-ignore-screenshot-element';
import { toScreenshotDataUrl } from 'utils/error-log/to-screenshot-data-url';
import { withTimeout } from 'utils/error-log/with-timeout';

export async function captureScreenSnapshot(): Promise<string | null> {
  if (typeof document === 'undefined' || !document.body) {
    return null;
  }

  const width = window.innerWidth;
  const height = window.innerHeight;
  const canvas = await withTimeout(
    html2canvas(document.body, {
      logging: false,
      useCORS: true,
      allowTaint: false,
      backgroundColor: '#ffffff',
      scale: getScreenshotScale(width, ERROR_LOG_SCREENSHOT_MAX_WIDTH),
      width,
      height,
      windowWidth: width,
      windowHeight: height,
      x: window.scrollX,
      y: window.scrollY,
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      ignoreElements: shouldIgnoreScreenshotElement
    }),
    ERROR_LOG_SCREENSHOT_TIMEOUT_MS
  );

  if (!canvas) {
    return null;
  }

  try {
    return toScreenshotDataUrl(
      canvas,
      ERROR_LOG_MAX_SCREENSHOT_CHARS,
      ERROR_LOG_SCREENSHOT_QUALITIES
    );
  } catch {
    return null;
  }
}
